<template>
  <div class="relative pt-[60] px-[50]">
    <div class="flex justify-between items-center">
      <p class="t-[26] t-[#303133] font-500">登录</p>
      <div class="flex overflow-hidden cursor-pointer rounded-[2] leading-[32] text-center">
        <p class="w-[60] t-[#606266] border-[#dcdfe6] border-y-[1px] border-l-[1px] border-solid"
          :class="{ '!t-[#fff] !bg-[theme] !border-[theme]': loginType == 0 }" @click="changeLoginType(0)">账号</p>
        <p :class="{ '!t-[#fff] !bg-[theme] !border-[theme]': loginType == 1 }" @click="changeLoginType(1)"
          class="w-[60] t-[#606266] border-[#dcdfe6] border-y-[1px] border-solid border-x-[1px] border-[#dcdfe6] border-solid">
          手机号</p>
        <p v-if="['fzb'].indexOf(conf.city) == -1" :class="{ '!t-[#fff] !bg-[theme] !border-[theme]': loginType == 2 }"
          @click="changeLoginType(2)"
          class="w-[60] t-[#606266] border-[#dcdfe6] border-y-[1px] border-r-[1px] border-solid">CA</p>
      </div>
    </div>
    <dg-alert-box ref="loginAlertRef" class="pt-[20]"
      :class="{ '!pt-[40]': !supportWxAuth && conf.city != 'huang-shi' }">
      <el-form :model="loginForm" ref="loginFormRef" label-width="1px">
        <div class="relative" v-show="loginType == 2">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">CA</div>
          <el-form-item label="" class="relative mb-[24]">
            <el-input size="large" class="large_input" :disabled="!isIE && ['liu-zhou'].indexOf(conf.city) == -1"
              placeholder="请插入CA" v-model="loginForm.caPassword">
              <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe610;</i>
            </el-input>
          </el-form-item>
        </div>

        <!-- <div v-show="loginType == 1 || loginType == 0"> -->
        <div class="relative" v-show="loginType == 0">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">账户</div>
          <el-form-item label="" prop="loginName" :rules="[{ required: loginType == 0, message: '请输入账户' }]"
            class="relative mb-[24]">
            <el-input size="large" class="large_input" placeholder="请输入账户" v-model="loginForm.loginName">
              <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe60d;</i>
            </el-input>
          </el-form-item>
        </div>
        <div class="relative" v-show="loginType == 1">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">手机号</div>
          <el-form-item label="" prop="mobile" :rules="[
            { required: loginType == 1, message: '请输入手机号' },
            { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请填写手机号' },
          ]" class="relative mb-[24]">
            <el-input size="large" class="large_input" placeholder="请输入手机号" maxlength="11" v-model="loginForm.mobile">
              <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe60d;</i>
            </el-input>
          </el-form-item>
        </div>
        <div class="relative" v-show="loginType == 0">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">登录密码</div>
          <el-form-item label="" prop="password" :rules="[{ required: loginType == 0, message: '请输入登录密码' }]"
            class="relative mb-[24]">
            <el-input size="large" class="large_input" placeholder="请输入登录密码" show-password v-model="loginForm.password">
              <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe60e;</i>
            </el-input>
          </el-form-item>
        </div>
        <div class="relative" v-show="loginType != 2">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">验证码</div>
          <el-form-item label="" class="mb-[24]" prop="catchcode"
            :rules="[{ required: loginType != 2, message: '请输入验证码' }]">
            <div class="flex">
              <div class="relative flex-1">
                <el-input size="large" class="large_input" placeholder="请输入验证码"
                  @keyup.enter.native="handleLogin('loginFormRef')" v-model="loginForm.catchcode">
                  <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe60c;</i>
                </el-input>
              </div>
              <div class="verificationCode w-[110] pl-[10]" @click="getcaptcha">
                <img v-if="verificationCode" :src="verificationCode" class="w-[100%] h-[100%]" alt="" />
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="relative" v-show="loginType == 1">
          <div v-if="!supportWxAuth && conf.city != 'huang-shi'" class="mb-[10] t-[#606266] t-[16]">短信验证码</div>
          <el-form-item label="" class="mb-[24]" prop="messagecode"
            :rules="[{ required: loginType == 1, message: '请输入短信验证码' }]">
            <div class="flex">
              <div class="relative flex-1 messagecode">
                <el-input @keyup.enter.native="handleLogin('loginFormRef')" size="large" class="large_input"
                  placeholder="请输入短信验证码" v-model="loginForm.messagecode">
                  <template v-slot:suffix>
                    <div
                      class="suffix cursor-pointer border-l-[1] border-[#d5dae5] border-solid w-[100] leading-[31] my-[9] t-[theme]"
                      @click="handleSend">{{ CountDownStatus ? "发送短信" : `${CountDownNum}/s` }}</div>
                  </template>
                  <i slot="prefix" class="el-input__icon icon t-[18] t-[theme]">&#xe60f;</i>
                </el-input>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- </div> -->
        <el-button size="default" class="w-[100%] !py-[16] !rounded-[4]" type="primary"
          @click="handleLogin('loginFormRef')">登录</el-button>
        <div class="flex justify-between pt-[10]">
          <p class="cursor-pointer t-[theme]" @click="push({ path: '/forgetPasw' })">忘记密码？</p>
          <p class="cursor-pointer t-[theme]" @click="goToRegister">快速注册</p>
        </div>
        <div class="mt-[24]" v-if="supportWxAuth || conf.city == 'huang-shi'">
          <div class="flex items-center">
            <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
            <p class="mx-[10] t-[#C0C4CC] t-[14]">其它登录方式</p>
            <div class="flex-1 h-[1] bg-[#DFE2E9]"></div>
          </div>
          <div class="flex justify-center items-center mt-[20]">
            <div class="cursor-pointer text-center" v-if="supportWxAuth" @click="handleLoginByWxScan">
              <img class="w-[44] h-[44]" src="@/assets/img/public/wx_login_icon.png" alt="" />
              <p class="t-[#606266] t-[12] pt-[8]">微信扫码</p>
            </div>
            <div class="cursor-pointer text-center" :class="{ 'ml-[90]': supportWxAuth }"
              v-if="conf.city == 'huang-shi'">
              <a :href="`${ENV.api}apis/hubei/uias_login.do`" target="_blank" class="t-[theme] no-underline">
                <img class="w-[44] h-[44]" :src="getCityAssetsFile(`hbtyrz.png`)" alt="" />
                <p class="t-[#606266] t-[12] pt-[8]">湖北统一认证登录</p>
              </a>
            </div>
          </div>
        </div>
      </el-form>
    </dg-alert-box>
    <!-- <div v-if="supportWxAuth" class="absolute right-[0] top-[0]" @click="handleLoginByWxScan">
      <img class="w-[50] h-[50] cursor-pointer" src="@/assets/img/public/scan_wx.png" alt="" />
    </div> -->
    <!-- <div class="text-center absolute bottom-[15] left-[0] right-[0]" v-if="conf.city == 'huang-shi'">
      <a :href="`${ENV.api}apis/hubei/uias_login.do`" target="_blank" class="t-[theme] no-underline"><i class="icon t-[14]">&#xe677;</i> 湖北省统一身份认证登录</a>
    </div> -->
  </div>
</template>

<script>
import CountDown from "@/assets/js/countDown";
import { deepCopyRef, encryptDES, isIE, rulTojson } from "../assets/js/utils";
import CAcontroller from "../assets/js/CAcontrol.js";
import SmsSenderCheck from "@/assets/js/SmsSenderCheck";
let smsSenderCheck = new SmsSenderCheck("login");
import mixin from "@/assets/js/mixin";
let CAcontrol = {};
export default {
  name: "loginByOthers",
  mixins: [mixin],
  props: {
    loginBy: {
      type: Number,
      default: 0,
    },
    supportWxAuth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isIE: isIE(),
      CountDownNum: 60,
      CountDownStatus: true,
      countDown: {},
      verificationCode: "",
      loginForm: {
        autoLogin: false,
        loginName: "", // 账户名 17750877007
        password: "", // 123456  密码，cookie值加上当前日期做密钥（JSESSIONID-yyyy-MM-dd），对明文进行des加密
        catchcode: "", // 图形验证码
        mobile: "", // 图形验证码
        messagecode: "", // 短信验证码
        caPassword: "", // ca密码
      },
      tips: {
        msg: "",
        type: "error",
      },
      loginType: this.loginBy,
    };
  },
  watch: {
    $route: {
      handler() {
        this.ca_back();
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 跳转微信扫码登录
    handleLoginByWxScan() {
      this.$emit("loginByWxScan");
    },

    // 跳转快速注册
    goToRegister() {
      this.$emit("goToRegister");
    },

    changeLoginType(type) {
      this.loginType = type;
      Mirror.emit("tips_el_alert_box_close");
    },
    ca_back() {
      if (isIE()) {
        // 判断是否为同意驱动跳转的
        setTimeout(() => {
          if (window.location.pathname.indexOf("ca.html") > -1 && localStorage.getItem("history_url_caSeal")) {
            // window.history.back(-1)
            let rul = localStorage.getItem("history_url_caSeal");
            localStorage.removeItem("history_url_caSeal");
            if (rul.indexOf("#") > -1) {
              rul = rul.split("#")[1];
              let path = rul.split("?")[0];
              this.$router.replace({ path, query: rulTojson(rul) });
            }
          }
        }, 100);
      }
    },
    /**
     * @author 伟健 / 张
     * @name 登录
     */
    handleLogin(formName) {
      Mirror.emit("tips_el_alert_box_close");
      if (this.loginType == 2) {
        this.handlerCaLogin(); //CA登录
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loginType == 1) {
            // 手机号登录
            ajax.post({
              url: "/customer/auth/mobileLogin",
              data: {
                messagecode: this.loginForm.messagecode, // 短信验证码
                mobile: this.loginForm.mobile, // 手机号
              },
              self: this,
              success: (res) => {
                console.log(res);
                if (res) {
                  this.getCurrent();
                }
              },
            });
          }
          if (this.loginType == 0) {
            // 密码登录
            let _loginForm = deepCopyRef(this.loginForm);
            _loginForm.password = encryptDES(_loginForm.password);
            ajax.post({
              url: "/customer/auth/login",
              data: _loginForm,
              self: this,
              success: (res) => {
                if (res) {
                  this.getCurrent();
                }
              },
              fail: () => {
                this.getcaptcha();
              },
            });
          }
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name ca 登录
     */
    async handlerCaLogin() { 
   
      Mirror.emit("tips_el_alert_box_close");

      if (!isIE() && ["yi-bin", "qing-dao", "bao-ding", 'liu-zhou'].indexOf(this.conf.city) == -1) {
        this.$message.error("请使用IE浏览器，并确保驱动已正确安装");
        return;
      }

      let loading = this.$loading({
        lock: true,
        text: "CA读取中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      if (CAcontrol.InitSignCer()) {

        let obj = await CAcontrol.getCAInfo(this.loginForm.caPassword);
        loading.close();
        console.log("obj", obj);
        try {
          if (!obj || !obj.certSerialNo) {
            loading.close();
            alert("系统未检测到CA证书，请检查锁是否插好后尝试登录！");

            return;
          }

          // this.loginForm.caPassword = obj.certSerialName;
          ajax.post({
            url: "/customer/auth/caKeysLogin",
            data: {
              certSerialName: obj.certSerialName, // 证书CN名称
              certSerialNo: obj.certSerialNo, // 证书序列号
            },
            self: this,
            success: (res) => {
              if (res.status == 1001) {
                this.$refs['loginAlertRef'].showTips({
                  msg: "当前CA证书未注册企业",
                  type: "warning",
                });
              }
              if (res.status == 1002) {
                this.$refs['loginAlertRef'].showTips({
                  msg: "该CA证书未绑定企业，请先使用账户或手机号登录，在用户中心中绑定CA再使用",
                  type: "warning",
                });
              }
              if (res.status == 1003) {
                this.$refs['loginAlertRef'].showTips({
                  msg: "当前CA证书已过期，请先进行更新CA证书",
                  type: "warning",
                });
              }
              if (res.status == 200) {
                this.getCurrent();
              }
            },
          });

          loading.close();
        } catch (error) {
          console.log(error);
          loading.close();
        }
      } else {
        loading.close();
        alert("CA读取失败");
      }
    },
    /**
     * @author 伟健 / 张
     * @name 用户信息
     */
    getCurrent() {
      ajax.post({
        url: "/customer/user/current",
        data: {},
        self: this,
        success: (res) => {
          console.log(res);
          if (res && res.user) {
            localStorage.setItem("current", JSON.stringify(res));
            if (this.$route.query.type == "loanApply") {
              this.push({ path: "/loan/apply" });
            } else {
              this.push({ path: "/" });
            }
          }
        },
      });
    },
    /**
     * @author 伟健 / 张
     * @name 发送短信
     */
    handleSend() {
      Mirror.emit("tips_el_alert_box_close");
      if (!this.countDown.checkStatus()) {
        return;
      }
      smsSenderCheck.check((valid, fn) => {
        if (valid) {
          let hasError = false;
          this.$refs["loginFormRef"].validateField(["mobile", "catchcode"], (err) => {
            if (err) {
              hasError = true;
              return;
            }
          });
          if (!hasError) {
            ajax.post({
              url: "/customer/auth/sendSmsCodeWithCheck",
              data: {
                catchcode: this.loginForm.catchcode, // 图形验证码
                mobile: this.loginForm.mobile, // 手机号码
              },
              self: this,
              success: (res) => {
                if (res) {
                  this.$refs['loginAlertRef'].showTips({
                    msg: "发送成功",
                    type: "warning",
                  });
                  this.countDown.start();
                  fn();
                }
              },
              fail: () => {
                this.loginForm.catchcode = "";
                this.getcaptcha();
              },
            });
          }
        } else {
          this.$refs['loginAlertRef'].showTips({
            msg: "短信发送频率过快，请稍后再试",
            type: "warning",
          });
          return;
        }
      });
    },
    /**
     * @author 伟健 / 张
     * @name
     */
    getcaptcha() {
      ajax.post({
        url: "/customer/common/getcaptcha",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.verificationCode = res;
          }
        },
      });
    },
  },
  mounted() {
    CAcontrol = new CAcontroller();
    CAcontrol.InitSignCer();
  },
  created() {
    this.getcaptcha();
    this.countDown = new CountDown({
      self: this,
      /*   这两参数必填
       "CountDownNum": 30,
       "CountDownStatus": true,
       */
      id: "login",
    });
  },
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";</style>
